import React from 'react';
import { useAuth } from './auth/AuthContext';

const AdminLogin = () => {
  const { loginWithGoogle, firebaseReady, authError } = useAuth();

  const handleClick = async () => {
    try {
      await loginWithGoogle();
    } catch (err) {
      // handled in auth context
    }
  };

  if (!firebaseReady) {
    return (
      <div style={{ maxWidth: 520, margin: '80px auto', padding: 24, border: '1px solid #ccc', borderRadius: 8 }}>
        <h2 style={{ marginTop: 0 }}>Authentication not configured</h2>
        <p>Firebase environment variables are missing. Configure Firebase to enable admin access.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: '2rem',
        background: '#fff',
        color: '#333',
        maxWidth: '480px',
        margin: '80px auto',
        border: '1px solid #ccc',
        borderRadius: '8px',
        textAlign: 'left',
        lineHeight: 1.5
      }}
    >
      <h2 style={{ marginTop: 0 }}>Games Banner Admin</h2>
      <p style={{ marginBottom: '1rem' }}>
        Sign in with your authorized Google account to manage games, widget keys, and logo mappings.
      </p>
      <p style={{ marginBottom: '1.5rem' }}>
        Access is restricted to email addresses in the admin allow list configured on the server.
      </p>
      {authError && (
        <div style={{ background: '#ffebee', color: '#c62828', padding: '8px 12px', borderRadius: 6, marginBottom: 12 }}>
          {authError}
        </div>
      )}
      <button
        type="button"
        onClick={handleClick}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: '#0b5ed7',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        Sign in with Google
      </button>
    </div>
  );
};

export default AdminLogin;
